import { render } from "./NormalDistribution.vue?vue&type=template&id=cb51cb44&scoped=true"
import script from "./NormalDistribution.vue?vue&type=script&lang=js"
export * from "./NormalDistribution.vue?vue&type=script&lang=js"

import "./NormalDistribution.vue?vue&type=style&index=0&id=cb51cb44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb51cb44"]])

export default __exports__